export const SAVE_NOTIFICATIONS_LIST = 'SAVE_NOTIFICATIONS_LIST'; 
export const SAVE_NOTIFICATION_DETAILS = 'SAVE_NOTIFICATION_DETAILS'; 